import { APIServicenowConfigAttributes } from '@ardoq/api-types/integrations';
import { fetchEntities } from './api';

export const servicenowConfigApi = {
  fetchAll: fetchEntities<APIServicenowConfigAttributes>(
    'integrations/servicenow/config'
  ),
};
